import React from 'react';
import { TextField, Box } from '@mui/material';

interface StringSearchInputProps {
  field: string;
  value: string | null;
  onChange: (value: string | null) => void;
  placeholder?: string;
}

export const StringSearchInput: React.FC<StringSearchInputProps> = ({
  field,
  value,
  onChange,
  placeholder
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onChange(newValue === '' ? null : newValue);
  };

  const handleClear = () => {
    onChange(null);
  };

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <TextField
        fullWidth
        size="small"
        label={placeholder || field}
        placeholder="Search"
        value={value || ''}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: value && (
            <Box
              component="span"
              onClick={handleClear}
              sx={{
                cursor: 'pointer',
                color: 'text.secondary',
                '&:hover': { color: 'text.primary' }
              }}
            >
              ✕
            </Box>
          )
        }}
        sx={{
          '& .MuiInputBase-input': {
            fontSize: '0.8125rem',
            py: 0.75,
          },
          '& .MuiInputBase-input::placeholder': {
            fontSize: '0.78rem',
          },
          '& .MuiInputLabel-root': {
            fontSize: '0.75rem',
            fontWeight: 600,
          },
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: 'primary.main',
            },
          },
        }}
      />
    </Box>
  );
};
